import BotsOverview from "../Campaigns/BotsOverview";
import { CampaignContext } from "../../contexts/CampaignContext";
import { useContext, useEffect, useRef, useState } from "react";
import FeatureControls from "../../components/FeatureControls/FeatureControls";
import { IconJsxer } from "../../helpers/IconHelper";
import { assets } from "../../assets/assets";
import Toggle from "../../components/forms/Toggle/Toggle";
import { FindParamArrayFromCustomisations, hasFeatureControlData } from "../../helpers/FeatureControlsHelper";
import { findFeatureChatCommands, findLinkedFeatureTriggers } from "../../helpers/CampaignsHelper";
import { getIconCategoryColor } from "../../components/common/iconCategory";
import LeftColorBlockBox, { LEFT_COLOR_BLOCK_STYLES } from "../../components/LeftColorBlockBox/LeftColorBlockBox";
import LeftColorBlockHeadedPanel from "../../components/LeftColorBlockBox/LeftColorBlockHeadedPanel";
import { OneListedCommand } from "../Campaigns/FeaturePanel/FeaturePanel";

const TabDisruptors = (props) => {
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    // const [currentDisruptor, setCurrentDisruptor] = useState(null);
    // const [previewMode, setPreviewMode] = useState(false);

    const selectDisruptor = (d) => {
        console.log('Select distruptor: ', d);
        props._setPreviewMode(false);
        props._setCurrentDisruptor(d);
    }

    const [expandedDisruptorTriggers, setExpandedDisruptorTriggers] = useState({});
    const setExpandedTriggerList = (id, expanded) => {
        setExpandedDisruptorTriggers((oldVal) => {
            const newVal = {...oldVal};
            newVal[id] = expanded;
            return (newVal)
        });
    }

    const [expandedChatCommands, setExpandedChatCommands] = useState({});
    const setExpandedChatCommandList = (id, expanded) => {
        setExpandedChatCommands((oldVal) => {
            const newVal = {...oldVal};
            newVal[id] = expanded;
            return (newVal)
        });
    }

    const categoryGroupStorageKey = `ms_tab2_category_groups_${props._streamId}`;
    const [expandedCategoryGroups, setExpandedCategoryGroups] = useState(() => {
        try {
            const storedValue = localStorage.getItem(categoryGroupStorageKey);
            return storedValue ? JSON.parse(storedValue) : null;
        } catch (e) {
            return null;
        }
    });

    const persistExpandedCategoryGroups = (nextValue) => {
        try {
            localStorage.setItem(categoryGroupStorageKey, JSON.stringify(nextValue));
        } catch (e) {}
    };

    const setExpandedCategoryGroup = (groupKey, expanded) => {
        setExpandedCategoryGroups((oldVal) => {
            const newVal = {...(oldVal || {})};
            newVal[groupKey] = expanded;
            persistExpandedCategoryGroups(newVal);
            return newVal;
        });
    }

    const [highlightedButtons, setHighlightedButtons] = useState([]);
    const highlightedButtons_ref = useRef([]);
    const highlightButton = (fId, command, buttonIndex) => {
        console.log('Hilight button: ', fId, command, buttonIndex);
        
        const newHighlightedButton = {group: fId, command: command, buttonIndex: buttonIndex};

        for (let i = 0; i < highlightedButtons_ref.current.length; i++) {
            if (highlightedButtons_ref.current[i].group === newHighlightedButton.group && highlightedButtons_ref.current[i].command === newHighlightedButton.command && highlightedButtons_ref.current[i].buttonIndex === newHighlightedButton.buttonIndex) {
                return;
            }
        }
        // We only get here if we didn't find a match
        const newHighlightedButtonsData = [...highlightedButtons_ref.current];
        newHighlightedButtonsData.push(newHighlightedButton);
        setHighlightedButtons(newHighlightedButtonsData);
        highlightedButtons_ref.current = newHighlightedButtonsData;
        setTimeout(() => {
            removeButtonHighlight(fId, command, buttonIndex);
        }, 300);
    }
    const removeButtonHighlight = (fId, command, buttonIndex) => {
        if (highlightedButtons_ref.current && highlightedButtons_ref.current.length > 0) {
            const newHighlightedButtonsData = highlightedButtons_ref.current.filter(
                (val, i, arr) => {
                    return !(val.group === fId && val.command === command && val.buttonIndex === buttonIndex);
                }
            )
            setHighlightedButtons(newHighlightedButtonsData);
            highlightedButtons_ref.current = newHighlightedButtonsData;
        }
    }
    const shouldHighlightButton = (fId, command, buttonIndex) => {
        for (let i = 0; i < highlightedButtons.length; i++) {
            if (highlightedButtons[i].group === fId && highlightedButtons[i].command === command && highlightedButtons[i].buttonIndex === buttonIndex) {
                return true;
            }
        }
        return false;
    }

    const getPreviewItemPayload = (featureItem, buttonConfig) => {
        const itemLabel = featureItem?.contentLabel;
        if (!itemLabel) {
            return null;
        }

        const controlsData = featureItem.feature;
        let commandData = null;
        if (typeof buttonConfig.command === 'number') {
            if (buttonConfig.command >= 0 && controlsData.commands.length > buttonConfig.command) {
                commandData = controlsData.commands[buttonConfig.command];
            }
        } else {
            commandData = controlsData.commands.find((command) => command.command === buttonConfig.command) || null;
        }

        if (!commandData || typeof commandData.param !== 'string') {
            return null;
        }

        let paramArray = null;
        if (Array.isArray(controlsData[commandData.param])) {
            paramArray = controlsData[commandData.param];
        } else {
            paramArray = FindParamArrayFromCustomisations(props._customisationVars, featureItem._id, commandData.param);
        }

        if (!Array.isArray(paramArray)) {
            return null;
        }

        return paramArray.find((pVal) => {
            const labelsToCheck = [pVal?.label, pVal?.name, pVal?.filename, pVal?.fileName, pVal?.title];
            return labelsToCheck.some((value) => typeof value === 'string' && value === itemLabel);
        }) || null;
    }

    const renderCompactActionButtons = (featureItem, triggered = false) => {
        const actionButtons = [];
        const controlsData = featureItem.feature;
        const renderFadeGraphIcon = () => (
            <svg
                className="feature-chain-fade-icon"
                viewBox="0 0 16 16"
                aria-hidden="true"
            >
                <path
                    d="M3 3V13"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                />
                <path
                    d="M8 6V13"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                />
                <path
                    d="M13 9V13"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                />
            </svg>
        );

        const getActionPriority = (buttonCommand, buttonColour, isPreview = false) => {
            if (isPreview) {
                return 40;
            }

            if (buttonCommand === 'FADE_OUT_AUDIO') {
                return 30;
            }

            if (buttonColour === 'green') {
                return 10;
            }

            if (buttonColour === 'red') {
                return 20;
            }

            if (buttonColour === 'orange') {
                return 30;
            }

            const matchedCommand = controlsData.commands.find((command) => command.command === buttonCommand);
            if (matchedCommand?.isPrimaryTrigger) {
                return 10;
            }

            if (matchedCommand?.isEndTrigger) {
                return 30;
            }

            return 40;
        };

        if (triggered) {
            return actionButtons;
        }

        featureItem.feature.defaultVars.forEach((varVal) => {
            if (!varVal.commandButtons || !varVal.commandButtons.length) {
                return;
            }

            varVal.commandButtons.forEach((cVal, cI) => {
                if (cVal.mainControl) {
                    let buttonCommand = cVal.command;
                    let param = null;
                    let paramArray = null;
                    if (typeof buttonCommand === 'number') {
                        if (buttonCommand >= 0 && controlsData.commands.length > buttonCommand) {
                            const command = controlsData.commands[buttonCommand]
                            buttonCommand = command.command;
                            if (typeof command.param === 'string' && Array.isArray(controlsData[command.param])) {
                                paramArray = controlsData[command.param];
                                param = 0;
                            } else {
                                if (typeof command.param === 'string') {
                                    paramArray = FindParamArrayFromCustomisations(props._customisationVars, featureItem._id, command.param);
                                }
                                if (paramArray === null) {
                                    param = command.param;
                                } else if (paramArray.length <= 1) {
                                    param = 0;
                                    paramArray = null;
                                }
                            }
                        }
                    }

                    let buttonColour = '';
                    if (cVal.colour) {
                        buttonColour = cVal.colour;
                    }
                    if (buttonColour === '') {
                        for (let i = 0; i < controlsData.commands.length; i++) {
                            if (controlsData.commands[i].command === buttonCommand) {
                                if (controlsData.commands[i].isPrimaryTrigger) {
                                    buttonColour = 'green';
                                }
                                if (controlsData.commands[i].isEndTrigger) {
                                    buttonColour = 'red';
                                }
                            }
                            if (buttonColour !== '') {
                                break;
                            }
                        }
                    }
                    if (buttonCommand === 'PLAY_AUDIO' || buttonCommand === 'PLAY_RANDOM_AUDIO') {
                        buttonColour = 'green';
                    }

                    if (paramArray === null || paramArray.length === 0) {
                        const isFadeOutButton = buttonCommand === 'FADE_OUT_AUDIO';
                        if (isFadeOutButton) {
                            buttonColour = 'purple';
                        }

                        actionButtons.push(
                            {
                                priority: getActionPriority(buttonCommand, buttonColour),
                                node: (
                                    <div className={`edit-icon live-qbut-${buttonColour}${shouldHighlightButton(featureItem._id, buttonCommand, cI) ? '-light' : ''}`} onClick={(e) => {e.stopPropagation(); highlightButton(featureItem._id, buttonCommand, cI); props._sendFeatureCommandFunc(e, buttonCommand, featureItem._id, param)}} key={'control_' + cI}>
                                        {isFadeOutButton && renderFadeGraphIcon()}
                                        {!isFadeOutButton && IconJsxer.ICONS[cVal.icon] &&
                                            IconJsxer.GetIcon(IconJsxer.ICONS[cVal.icon], IconJsxer.ICON_STYLES.campaignPanelTop)
                                        }
                                        {!isFadeOutButton && !IconJsxer.ICONS[cVal.icon] && assets[cVal.icon] &&
                                            <img src={assets[cVal.icon]} style={IconJsxer.ICON_STYLES.campaignPanelTop} alt="" />
                                        }
                                    </div>
                                )
                            }
                        );
                    }
                }

                if (cVal.addPreviewButton && cVal.previewCommand && cVal.previewIcon) {
                    const previewParam = getPreviewItemPayload(featureItem, cVal);
                    if (previewParam) {
                        actionButtons.push(
                            {
                                priority: getActionPriority(cVal.previewCommand, 'purple', true),
                                node: (
                                    <div className={`edit-icon live-qbut-purple${shouldHighlightButton(featureItem._id, cVal.previewCommand, cI) ? '-light' : ''}`} onClick={(e) => {e.stopPropagation(); highlightButton(featureItem._id, cVal.previewCommand, cI); props._sendFeatureCommandFunc(e, cVal.previewCommand, featureItem._id, previewParam)}} key={'preview_control_' + cI}>
                                        {IconJsxer.GetIcon(IconJsxer.ICONS[cVal.previewIcon], IconJsxer.ICON_STYLES.campaignPanelTop)}
                                    </div>
                                )
                            }
                        );
                    }
                }
            });
        });

        return actionButtons
            .sort((a, b) => a.priority - b.priority)
            .map((action) => action.node);
    }

    const getDisruptorPanel = (val, i, triggered = false, triggerDepth = 0) => {
        // console.log('Get disruptor panel for: ', val);
        let foundDynamicButtons = false;
        val.feature.defaultVars.forEach(varVal => {
            if (varVal.commandButtons && varVal.commandButtons.length) {
                varVal.commandButtons.forEach(cVal => {
                    if (cVal.mainControl) {
                        const controlsData = val.feature;
                        let buttonCommand = cVal.command;
                        let paramArray = null;
                        if (typeof buttonCommand === 'number') {
                            // We have a number as a command, so we need to look this one up!
                            if (buttonCommand >= 0 && controlsData.commands.length > buttonCommand) {
                                const command = controlsData.commands[buttonCommand]
                                buttonCommand = command.command;
                                if (typeof command.param === 'string' && Array.isArray(controlsData[command.param])) {
                                    // Kind of a legacy type so we can keep the multiple param buttons working while getting customisation up and running.
                                    // We have a param that references an array property in our feature, our label should show something relevant to the param
                                    paramArray = controlsData[command.param];
                                } else {
                                    if (typeof command.param === 'string') {
                                        // console.log('Finding param array for: ', command.param, props._customisationVars, val._id);
                                        paramArray = FindParamArrayFromCustomisations(props._customisationVars, val._id, command.param);
                                    }
                                }
                            }
                        }
                        if (paramArray && paramArray.length > 1) {
                            foundDynamicButtons = true;
                        }
                    }
                });
            }
        });

        let boxStyle = val.feature.featureType;
        if (LEFT_COLOR_BLOCK_STYLES[val.feature.featureType + '_' + val.feature.varKey]) {
            boxStyle = val.feature.featureType + '_' + val.feature.varKey;
        }
        if (LEFT_COLOR_BLOCK_STYLES['disruptor_' + val.feature.colourCategory]) {
            boxStyle = 'disruptor_' + val.feature.colourCategory;
        }
        if (LEFT_COLOR_BLOCK_STYLES['category_' + val.feature.colourCategory]) {
            boxStyle = 'category_' + val.feature.colourCategory;
        }
        const componentCategory = val.feature.iconCategory || val.feature.featureCategory;
        const componentColor = componentCategory ? getIconCategoryColor(componentCategory) : null;
        const triggeredDisruptors = findLinkedFeatureTriggers(val._id, campaignContext.campaignData, props._customisationVars?.current);
        const chatCommands = findFeatureChatCommands(val._id, campaignContext.campaignData);
        const selectedFeatureSurface = props._currentDisruptor === val ? 'var(--feature-chain-selected-surface, #DDDDEE)' : '';
        let hasChatCommands = false;
        if (chatCommands && chatCommands.length > 0) {
            for (let i = 0; i < chatCommands.length; i++) {
                if (chatCommands[i].hashtags && chatCommands[i].hashtags.length > 0) {
                    hasChatCommands = true;
                    break;
                }
            }
        }

        if ((!foundDynamicButtons && triggeredDisruptors.length === 0 && !hasChatCommands) || triggered) {
            return (
                <div className="fl-column compact" key={'disruptor_' + i}>
                    <div className="fl-row grow">
                        {triggerDepth > 0 &&
                            <div className="light-text triggered-feature-indent">
                                {/*IconJsxer.GetIcon(IconJsxer.ICONS.arrowCircleRight, IconJsxer.ICON_STYLES.analyticsColourBlockIcon)*/}
                            </div>
                        }
                        <LeftColorBlockBox
                            style={boxStyle}
                            overrideBgColor={selectedFeatureSurface}
                            customColor={componentColor}
                            customIcon={val.feature.icon}
                            customIconVarKey={val.feature.varKey}
                            whiteIcon={Boolean(componentColor)}
                            neutralBorder={true}
                            iconBoxOnly={true}
                            compact={true}
                            className={`feature-chain-card${props._currentDisruptor === val ? ' is-selected' : ''}`}
                            onClickHandler={() => selectDisruptor(val)}
                        >
                            <div className="fl-row list-view-content">

                                <div className="grow feature-chain-text">
                                    <div className="feature-chain-title">{val.contentLabel || `Disruptor Name #${i + 1}`}</div>
                                    <div className="feature-chain-subtitle">({val.feature.featureName})</div>
                                </div>

                                <div className="fl-row shrink chain-selector-actions">
                                {renderCompactActionButtons(val, triggered)}

                                <div className="edit-icon feature-chain-settings-icon" onClick={(e) => { e.stopPropagation(); selectDisruptor(val); }}>
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.controls, IconJsxer.ICON_STYLES.campaignPanelTop)}
                                </div>
                                </div>
                            </div>
                        </LeftColorBlockBox>
                    </div>

                    {triggeredDisruptors.length > 0 && triggerDepth === 0 &&
                        <>
                            <div className="fl-column compact">
                                {triggeredDisruptors.map(
                                    (val_tf, i_tf, arr_tf) => getDisruptorPanel(val_tf, i_tf, true, 1)
                                )}
                            </div>
                        </>
                    }

                </div>
            )
        }

        return (
            <LeftColorBlockHeadedPanel style={boxStyle} overrideBgColor={selectedFeatureSurface} key={'disruptor_' + i}
                className="feature-chain-panel"
                customColor={componentColor}
                customIcon={val.feature.icon}
                customIconVarKey={val.feature.varKey}
                whiteIcon={Boolean(componentColor)}
                neutralBorder={true}
                iconBoxOnly={true}
                compact={true}
                boxClassName={`feature-chain-card${props._currentDisruptor === val ? ' is-selected' : ''}`}
                onClickHandler={() => selectDisruptor(val)}
                headingContent={
                    <div className="fl-row list-view-content">

                        <div className="grow feature-chain-text">
                            <div className="feature-chain-title">{val.contentLabel || `Disruptor Name #${i + 1}`}</div>
                            <div className="feature-chain-subtitle">({val.feature.featureName/*val.feature.featureType !== 'feature' ? val.feature.featureName : 'Main Feature'*/})</div>
                        </div>

                        <div className="fl-row shrink chain-selector-actions">
                        {renderCompactActionButtons(val)}

                        {// val.feature.featureType !== 'feature' &&
                            <div className="edit-icon feature-chain-settings-icon" onClick={(e) => { e.stopPropagation(); selectDisruptor(val); }}>
                                {IconJsxer.GetIcon(IconJsxer.ICONS.controls, IconJsxer.ICON_STYLES.campaignPanelTop)}
                            </div>
                        }
                        </div>
                    </div>
                }>

                    {foundDynamicButtons &&
                        <>

                            {val.feature.defaultVars.map(
                                (varVal, varI, varArr) => {
                                    // console.log('Sorting out buttons: ', val);
                                    if (varVal.commandButtons && varVal.commandButtons.length) {
                                        return varVal.commandButtons.map(
                                            (cVal, cI, cArr) => {
                                                if (cVal.mainControl) {
                                                    const controlsData = val.feature;
                                                    let buttonLabel = cVal.label;
                                                    if (IconJsxer.ICONS[cVal.icon]) {
                                                        buttonLabel = IconJsxer.GetIcon(IconJsxer.ICONS[cVal.icon], IconJsxer.ICON_STYLES.campaignPanelTop)
                                                    } else
                                                        if (assets[cVal.icon]) {
                                                            buttonLabel = <img src={assets[cVal.icon]} style={IconJsxer.ICON_STYLES.campaignPanelTop} alt="" />
                                                        }
                                                    let buttonCommand = cVal.command;
                                                    let param = null;
                                                    let paramArray = null;
                                                    if (typeof buttonCommand === 'number') {
                                                        // We have a number as a command, so we need to look this one up!
                                                        if (buttonCommand >= 0 && controlsData.commands.length > buttonCommand) {
                                                            const command = controlsData.commands[buttonCommand]
                                                            buttonCommand = command.command;
                                                            if (typeof command.param === 'string' && Array.isArray(controlsData[command.param])) {
                                                                // Kind of a legacy type so we can keep the multiple param buttons working while getting customisation up and running.
                                                                // We have a param that references an array property in our feature, our label should show something relevant to the param
                                                                paramArray = controlsData[command.param];
                                                                param = 0;
                                                            } else {
                                                                if (typeof command.param === 'string') {
                                                                    // console.log('Finding param array for: ', command.param, props._customisationVars, val._id);
                                                                    paramArray = FindParamArrayFromCustomisations(props._customisationVars, val._id, command.param);
                                                                }
                                                                if (paramArray === null) {
                                                                    param = command.param;
                                                                }
                                                            }
                                                        }
                                                    }

                                                    let buttonColour = '';
                                                    if (cVal.colour) {
                                                        buttonColour = cVal.colour;
                                                    }
                                                    if (buttonColour === '') {
                                                        // Based on the command, we can set a default colour. isPrimaryTrigger = green and isEndTrigger = red
                                                        for (let i = 0; i < controlsData.commands.length; i++) {
                                                            if (controlsData.commands[i].command === buttonCommand) {
                                                                if (controlsData.commands[i].isPrimaryTrigger) {
                                                                    buttonColour = 'green';
                                                                }
                                                                if (controlsData.commands[i].isEndTrigger) {
                                                                    buttonColour = 'red';
                                                                }
                                                            }
                                                            if (buttonColour !== '') {
                                                                break;
                                                            }
                                                        }
                                                    }

                                                    if (paramArray && paramArray.length > 0) {
                                                        return (
                                                            <div className="feature-controls-holder" style={{ marginBottom: 0, paddingBottom: 0 }} key={'bgrp_' + cI}>
                                                                <div className="button-grid" style={{ marginBottom: 0 }}>
                                                                    {paramArray.map(
                                                                        (pVal, pI, pArr) => {
                                                                            return (
                                                                                <button key={'btn_' + pI} className={`standard-button live-but-${buttonColour}`} onClick={(e) => {highlightButton(val._id, buttonCommand, pI); props._sendFeatureCommandFunc(e, buttonCommand, val._id, pI)}}>
                                                                                    {typeof buttonLabel !== 'object' &&
                                                                                        <>
                                                                                            {buttonLabel} {(pVal.label || pVal.name || pVal.fileName || pVal.filename)}
                                                                                        </>
                                                                                    }
                                                                                    {typeof buttonLabel === 'object' &&
                                                                                        <div className="fl-row">
                                                                                            {buttonLabel}
                                                                                            <div>
                                                                                                {(pVal.label || pVal.name || pVal.fileName || pVal.filename)}
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                    {shouldHighlightButton(val._id, buttonCommand, pI) &&
                                                                                        <>
                                                                                            <div className="live-but-highlighted-overlay"></div>
                                                                                            <img className="live-but-spinner" src={assets.ButtonSpinner} alt="" />
                                                                                        </>
                                                                                    }
                                                                                </button>
                                                                            )
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )
                                                    }

                                                    foundDynamicButtons = true;
                                                    return null;
                                                } else {
                                                    return null;
                                                }
                                            }
                                        )
                                    }
                                    return null;
                                }
                            )}

                        </>
                    }

                    {triggeredDisruptors.length > 0 &&
                        <>
                            <div className="fl-row">
                                <h5 className="tight">Triggered Disruptors</h5>
                                <div className="grow"></div>
                                <div className="fl-row compact cursor-pointer" onClick={(e) => setExpandedTriggerList(val._id, expandedDisruptorTriggers[val._id] ? false : true)}>
                                    <div>{expandedDisruptorTriggers[val._id] ? 'Hide' : 'Show'}</div>
                                    {
                                        IconJsxer.GetIcon(expandedDisruptorTriggers[val._id] ? IconJsxer.ICONS.chevronUp : IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.standard)
                                    }
                                </div>
                            </div>
                            <hr className="tight-hr"></hr>
                            <div className={`fl-column compact disruptor-triggers-list${expandedDisruptorTriggers[val._id] ? ' dtl-expanded' : ''}`}>
                                {triggeredDisruptors.map(
                                    (val_tf, i_tf, arr_tf) => getDisruptorPanel(val_tf, i_tf, true, 0)
                                )}
                            </div>
                        </>
                    }

                    {hasChatCommands &&
                        <>
                            {(triggeredDisruptors.length > 0 || foundDynamicButtons) &&
                                <div className="spacer"></div>
                            }
                            <div className="fl-row feature-chain-chat-commands-header">
                                <h5 className="tight">Chat Commands</h5>
                                <div className="grow"></div>
                                <div className="shrink">
                                    <Toggle id={'chatCommands_' + val._id} currentState={props._liveStreamServerState?.disabledChatCommandFeatureIds?.indexOf(val._id) === -1 ?? false} toggleFunc={(e) => {props._toggleChatCommandEnabled(val._id)}} enabled={props._chatConnected}></Toggle>
                                </div>
                                <div className="fl-row compact cursor-pointer" onClick={(e) => setExpandedChatCommandList(val._id, expandedChatCommands[val._id] ? false : true)}>
                                    <div>{expandedChatCommands[val._id] ? 'Hide' : 'Show'}</div>
                                    {
                                        IconJsxer.GetIcon(expandedChatCommands[val._id] ? IconJsxer.ICONS.chevronUp : IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.standard)
                                    }
                                </div>
                            </div>
                            <hr className="tight-hr"></hr>
                            <div className={`fl-column compact disruptor-triggers-list feature-chain-chat-commands${expandedChatCommands[val._id] ? ' dtl-expanded' : ''}`}>
                                    <div className="feature-panel feature-panel-compact-chat">
                                        <div className="inner-panel compact-chat-panel">
                                            <div className="scroll-container add-margin compact-chat-scroll">
                                                <div className="grid less-detail compact-chat-grid">
                                                    <div className="header label fl-row">Control</div>
                                                    <div className="header label fl-row">Chat</div>
                                                    <div className="header label fl-row">Cooldown</div>
                                                    {/* <hr></hr> */}
                                                    {chatCommands.map(
                                                        (val_c, i_c, arr_c) => {
                                                            // console.log('Listing commands: ', val_c);
                                                            return (
                                                                <OneListedCommand
                                                                    key={'olc_' + i_c}
                                                                    _val={val_c}
                                                                    _featureData={val}
                                                                    _editMode={false}
                                                                    _removeHashtag={null}
                                                                    _campaignId={props._campaignId}
                                                                    _customisationData={props._customisationVarsRef}
                                                                    _gotLiveStream={true}
                                                                    _reducedDetail={true}
                                                                />
                                                            )
                                                        }
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </>
                    }

            </LeftColorBlockHeadedPanel>
        )
            
    }

    let themeable = false;
    if (props._currentDisruptor) {
        // Check tabs in featureData for any themeable tabs
        const featureData = props._currentDisruptor;
        for (let i = 0; i < featureData.feature.customisation.length; i++) {
            if (featureData.feature.customisation[i].themeable) {
                themeable = true;
                break;
            }
        }
    }

    const getCategoryLabel = (featureItem) => {
        const featureData = featureItem?.feature || {};
        const categoryValue = Array.isArray(featureData.featureCategory)
            ? featureData.featureCategory[0]
            : featureData.featureCategory;
        const featureMetaText = [
            featureData.varKey,
            featureData.featureName,
            featureData.defaultAssetFolder,
            featureData.featureURL,
        ].filter(Boolean).join(' ').toLowerCase();

        if (featureMetaText.includes('image')) {
            return 'Images';
        }

        if (featureMetaText.includes('video')) {
            return 'Videos';
        }

        if (featureMetaText.includes('audio')) {
            return 'Audio';
        }

        if (featureData.isTwitchArcade || categoryValue === 'Arcade/IRL' || categoryValue === 'Features') {
            return 'Features';
        }

        return featureData.iconCategory || categoryValue || 'Other';
    };

    const getCategorySortWeight = (categoryLabel) => {
        if (categoryLabel === 'Features') {
            return 0;
        }

        if (categoryLabel === 'Visual Components') {
            return 40;
        }

        if (categoryLabel === 'Effects') {
            return 50;
        }

        if (categoryLabel === 'Images') {
            return 900;
        }

        if (categoryLabel === 'Videos') {
            return 910;
        }

        if (categoryLabel === 'Audio') {
            return 920;
        }

        if (categoryLabel === 'Core') {
            return 999;
        }

        return 100;
    };

    const categoryGroups = [];
    const categoryGroupMap = new Map();

    props._features.forEach((featureItem, featureIndex) => {
        if (featureItem.isChained) {
            return;
        }

        const categoryLabel = getCategoryLabel(featureItem);
        const categoryKey = String(categoryLabel).toLowerCase().replace(/[^a-z0-9]+/g, '-');

        if (!categoryGroupMap.has(categoryKey)) {
            const newGroup = {
                key: categoryKey,
                label: categoryLabel,
                items: [],
            };
            categoryGroupMap.set(categoryKey, newGroup);
            categoryGroups.push(newGroup);
        }

        categoryGroupMap.get(categoryKey).items.push({
            featureItem,
            featureIndex,
        });
    });

    categoryGroups.sort((a, b) => {
        const weightDiff = getCategorySortWeight(a.label) - getCategorySortWeight(b.label);
        if (weightDiff !== 0) {
            return weightDiff;
        }

        return String(a.label).localeCompare(String(b.label));
    });

    useEffect(() => {
        if (expandedCategoryGroups !== null || categoryGroups.length === 0) {
            return;
        }

        const initialExpandedState = {};
        categoryGroups.forEach((categoryGroup, categoryIndex) => {
            initialExpandedState[categoryGroup.key] = categoryIndex === 0;
        });

        setExpandedCategoryGroups(initialExpandedState);
        persistExpandedCategoryGroups(initialExpandedState);
    }, [expandedCategoryGroups, categoryGroups, categoryGroupStorageKey]);

    const featureControlsReady = hasFeatureControlData(
        props._currentDisruptor,
        props._featureVars,
        props._customisationVars
    );

    return (
        <div className="fl-column no-panel-shadow">
            <LeftColorBlockHeadedPanel
                style={props._previewMode ? 'preview_mode' : props._currentDisruptor ? 'campaign_live' : 'disabled_mode'}
                className={`cf-status-panel${!props._currentDisruptor ? ' cf-status-inactive' : ''}`}
                headingContent={
                    <div className="cf-status-heading-text grow">
                        <div className="fl-row">
                            <h4>{props._previewMode ? 'Preview Mode' : 'Live Mode'}</h4>
                            <div className="grow"></div>
                            {props._currentDisruptor && props._chatConnected && props._featureReady &&
                                <button className="standard-button tight cf-dry-run-btn" onClick={() => props._setPreviewMode(!props._previewMode, props._currentDisruptor, '(Disruptor)')}>
                                    {props._previewMode ? 'Exit Preview' : 'Test Preview'}
                                </button>
                            }
                        </div>
                        <div className="cf-status-body">
                            {!props._previewMode && props._currentDisruptor && <>You are running in live mode. Commands will be sent to all active extension pages.</>}
                            {props._previewMode && <>Commands will be sent to the preview window. Note: settings changes will still be sent to active extension pages.</>}
                            {!props._currentDisruptor && <>Please select a Feature or Disruptor to view its controls.</>}
                        </div>
                    </div>
                }
            />

            <div className="split-content">
                <div className="shrink-column">
                    <div className="scroll-area _42">
                        <div className="fl-column compact">
                            {categoryGroups.map((categoryGroup, categoryIndex) => {
                                const expanded = expandedCategoryGroups === null
                                    ? categoryIndex === 0
                                    : Boolean(expandedCategoryGroups[categoryGroup.key]);

                                return (
                                    <div className="feature-category-section" key={`category_${categoryGroup.key}`}>
                                        {categoryIndex > 0 && <div className="spacer"></div>}
                                        <button
                                            className={`feature-category-toggle${expanded ? ' is-expanded' : ''}`}
                                            onClick={() => setExpandedCategoryGroup(categoryGroup.key, !expanded)}
                                            type="button"
                                        >
                                            <span className="feature-category-toggle-label">{categoryGroup.label}</span>
                                            <span className="feature-category-toggle-count">{categoryGroup.items.length}</span>
                                            {IconJsxer.GetIcon(expanded ? IconJsxer.ICONS.chevronUp : IconJsxer.ICONS.chevronDown, IconJsxer.ICON_STYLES.standard)}
                                        </button>

                                        {expanded && (
                                            <div className="feature-category-list fl-column compact">
                                                {categoryGroup.items.map(({ featureItem, featureIndex }) => {
                                                    return (
                                                        <div key={`${categoryGroup.key}_${featureItem._id || featureIndex}`}>
                                                            {getDisruptorPanel(featureItem, featureIndex)}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="column no-panel-shadow">
                    {props._currentDisruptor &&
                        <div className="underlined-panel-heading">
                            <h4>{`${props._currentDisruptor.contentLabel} Controls`}</h4>
                            <div className="grow"></div>
                        </div>
                    }
                    <div className={`ms-full-scroll-area${!props._currentDisruptor ? ' cf-empty-controls' : ''}`}>
                        <div className="fl-column">
                            {!props._currentDisruptor &&
                                <div className="cf-no-feature-message">
                                    {IconJsxer.GetIcon(IconJsxer.ICONS.error, {height: '2.5rem'})}
                                    <p>Feature controls will appear here once you select a feature from the list on the left.</p>
                                </div>
                            }
                            {featureControlsReady &&
                                <FeatureControls
                                    hideHeading={true}
                                    feature={props._currentDisruptor}
                                    streamVars={props._featureVars.current}
                                    featureId={props._currentDisruptor._id}
                                    campaignId={props._campaignId}
                                    streamId={props._streamId}
                                    socket={props.socket}
                                    customisationVars={props._customisationVars}
                                    reportFeatureVarsChangedFunc={props._reportFeatureVarsChanged}
                                    reportCustomisationVarsChanged={props._reportCustomisationVarsChanged}
                                    saveCustomisationVarsFunc={props._saveCustomisationVarsFunc}
                                    sendFeatureCommandFunc={props._sendFeatureCommandFunc}
                                    rebuildLivePollLeaderboardFunc={props._rebuildLivePollLeaderboardFunc}
                                    pollLeaderboardCacheReady={props._pollLeaderboardCacheReady}
                                    setLivePollLeaderboardPlayerIgnoredFunc={props._setLivePollLeaderboardPlayerIgnoredFunc}
                                    restoreLivePollFunc={props._restoreLivePollFunc}
                                    showLivePollRunFunc={props._showLivePollRunFunc}
                                    showTooltipFunc={props._showTooltip}
                                    hideTooltipFunc={props._hideTooltip}
                                    label={props._currentDisruptor.contentLabel}
                                    quizData={props._allQuizData ? (props._allQuizData[props._currentDisruptor._id] || null) : null}
                                    startCollapsed={false}
                                    forceCollapsed={false}
                                    chatConnected={props._chatConnected}
                                    featureReady={props._featureReady}
                                    isThemeable={themeable}
                                    themeData={props._themeData}
                                    applyThemeFunc={props._applyThemeFunc}
                                    openRestrictedCustomisation={props.openRestrictedCustomisation}
                                    channels={props.channels}
                                    campaignChannels={props.campaignChannels}
                                    expeditionDataFetched={props.expeditionDataFetched}
                                    key={props._currentDisruptor._id}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default TabDisruptors
